import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/privacy-policy/page.tsx");
